import clsx from 'clsx';
import React from 'react';

const DisplayNewItem = (props) => {
  const { newValue, actionTypeLabel } = props;

  return (
    <React.Fragment>
      <span className={clsx('tw-text-cfo-black')}>{actionTypeLabel}</span>
      <span className={clsx('tw-text-cfo-black')}>{newValue}</span>
    </React.Fragment>
  );
};

export default DisplayNewItem;
